module.exports = __webpack_public_path__ + "static/media/_F5-GreenSock.311d59a6.svg";